export default __webpack_public_path__ + "static/media/partner-ship-bg.be4e9ee2.webp";